import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import React, {useEffect, useState} from "react";

const CheckupModal = ({ cogLoad, switchCL }) => {
    const [show, setShow] = useState(false)

    const handleClose = () => {
        setShow(false)
    }

    useEffect(() => {
        if (cogLoad === 'vvl') {
            setShow(true)
        }
    }, [cogLoad])

    return (
        <Modal show={cogLoad === 'vvh' && show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Check up!</Modal.Title>
            </Modal.Header>
            <Modal.Body>Hey there. You're looking a little tired. Why don't you take a break?</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={switchCL}>Disregard</Button>
                <Button variant="primary" onClick={handleClose}>Mmkay</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CheckupModal
